import { LevelType, PositionType, SpaceType } from 'data/types';
import { getEffectiveFootprintPolygons } from 'utils/footprint-polygons';
import {
  distanceFromSquareToNearestExteriorWall,
  snapOutsidePolygons,
  spaceSnapPolygons
} from 'utils/wall-snap';

const DETACHED_TOLERANCE_FT = 0.01;

export function snapAutoPlacedCondenser(
  position: PositionType,
  level: LevelType,
  spaces: SpaceType[],
  sizeFt: number,
  gapFt: number
): PositionType {
  const polygons = spaceSnapPolygons(spaces);
  if (polygons.length === 0) {
    return position;
  }
  const footprints = getEffectiveFootprintPolygons(level);
  const center = { x: position.x + sizeFt / 2, y: position.y + sizeFt / 2 };
  const distance = distanceFromSquareToNearestExteriorWall(
    center,
    sizeFt,
    polygons,
    { footprints }
  );
  if (distance <= gapFt + sizeFt + DETACHED_TOLERANCE_FT) {
    return position;
  }
  const snapped = snapOutsidePolygons(center, sizeFt, polygons, {
    footprints,
    gapFt
  });
  return snapped ? { x: snapped.x, y: snapped.y } : position;
}
